import React, { useId } from "react";
import { createPortal } from "react-dom";
import ReactTooltip from "react-tooltip";
import InfoIconMaterial from "./InfoIconMaterial";
import "./InfoTip.css";

/**
 * The app's info button: an (i) that shows its explanation in a small card on hover / keyboard
 * focus (tap on touch screens). One look everywhere — sidebar switches, settings rows, room
 * settings, chat info.
 *
 *   <InfoTip title="Kjuup-Chats" text="Kjuup-Chats in allen Bereichen ein- oder ausblenden." />
 *
 * `title` (optional) heads the card in semibold; `text` may be a string or nodes. The card is
 * portalled to <body>, so scroll areas and overflow:hidden parents cannot clip it.
 * A click on the button does nothing else (it never toggles the row it sits in).
 */
export default function InfoTip({ title, text, place = "top", disabled = false, small = true, className = "", label }) {
  const id = `kj-info-tip-${useId().replace(/:/g, "")}`;
  if (!text) return null;
  const ariaLabel = label || [title, typeof text === "string" ? text : null].filter(Boolean).join(": ") || "Info";
  return (
    <>
      <button
        type="button"
        className={`kj-info-tip${disabled ? " is-disabled" : ""}${className ? ` ${className}` : ""}`}
        aria-label={ariaLabel}
        data-tip
        data-for={id}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <InfoIconMaterial disabled={disabled} menuInline={small} />
      </button>
      {typeof document !== "undefined"
        ? createPortal(
            <ReactTooltip
              id={id}
              place={place}
              effect="solid"
              className="kj-info-tip-card"
              backgroundColor="#fff"
              textColor="#3c3c3c"
              border
              borderColor="#dce3ea"
              arrowColor="#fff"
              delayShow={150}
            >
              {title ? <span className="kj-info-tip-card__title">{title}</span> : null}
              <span className="kj-info-tip-card__text">{text}</span>
            </ReactTooltip>,
            document.body
          )
        : null}
    </>
  );
}
